import { Controller } from "stimulus";
import autoComplete from "@tarekraafat/autocomplete.js";
import sortable from "html5sortable/dist/html5sortable.es";
import { fetchStream, windowURL } from "@/src/utils/common";

export default class extends Controller {
  static targets = ['offices', 'emptyState']
  officesSelector = null;
  officesSortable = null;

  connect() {
    this.initializeAutocomplete();
    this.enableDisableSave();

    this.officesSortable = sortable(".js-sortable", {
      items: ".office-form",
      forcePlaceholderSize: true,
      placeholderClass: "office-placeholder",
      acceptFrom: ".js-sortable",
      customDragImage: (draggedElement, elementOffset, event) => {
        return {
          element: draggedElement.querySelector(".office-form summary"),
          posX: event.pageX - elementOffset.left,
          posY: event.pageY - elementOffset.top
        }
      }
    });
  }

  initializeAutocomplete() {
    document.querySelector("#office-selector")?.addEventListener("init", (e) => {
      const target = e.target;
      if (target.value.length) this.officesSelector?.start(target.value);
    });

    this.officesSelector = new autoComplete({
      selector: "#office-selector",
      placeholder: "Search for an existing office",
      threshold: 2,
      debounce: 300,
      data: {
        src: async (query) => {
          try {
            const response = await fetch(`/api/v1/search/offices?term=${encodeURIComponent(query)}`);
            const data = await response.json();
            return data;
          } catch (error) {
            console.error('Error fetching offices:', error);
            return error;
          }
        },
        keys: ["name"]
      },
      resultsList: {
        noResults: true,
        maxResults: 20,
        tabSelect: true
      },
      resultItem: {
        highlight: true,
      },
      events: {
        input: {
          focus: () => {
            if (this.officesSelector.input.value.length) this.officesSelector.start(this.officesSelector.input.value);
          }
        },
      }
    });

    this.officesSelector.input.addEventListener("selection", this.onOfficeSelected.bind(this));
  }

  onOfficeSelected(e) {
    const fromDataset = e?.target?.dataset?.officeId
    const fromSelection = e?.detail?.selection?.value?.id
    const officeId = (fromDataset || fromSelection)?.toString()?.trim()

    if (!officeId) return

    fetchStream(
      "GET",
      `${windowURL}/office_profile?id=${officeId}`,
      {
        target: this.officesTarget.id,
      },
      () => setTimeout(this.enableDisableSave.bind(this), 500)
    );
  }

  addSuggestedOffice(e){
    this.onOfficeSelected(e)
    const row = e.target.closest('tr')
    if (row){
      row.remove()
    }
  }

  removeOffice(e) {
    try {
      const formContainer = e.target.closest(".office-form")
      const checkbox = formContainer.querySelector("input[type=checkbox]");
      checkbox.checked = false;
      formContainer.style.display = "none";
    } catch(e) {
      console.error("Error removing office:", e);
    }
    this.enableDisableSave();
  }

  enableDisableSave() {
    const inputs = this.officesTarget.querySelectorAll("input[type=checkbox]");
    const enable = Array.from(inputs).some(checkbox => checkbox.checked);

    const saveButtons = document.querySelectorAll(".save-actions button[type=submit]");

    saveButtons.forEach(button => {
      button.disabled = !enable;
    });
    this.emptyStateTarget.style.display = enable ? "none" : "flex";
  }
}
